import { render, staticRenderFns } from "./pay_groups.vue?vue&type=template&id=81aeb13a"
import script from "./pay_groups.vue?vue&type=script&lang=js"
export * from "./pay_groups.vue?vue&type=script&lang=js"
import style0 from "./pay_groups.vue?vue&type=style&index=0&id=81aeb13a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports